import { css, styled } from "styled-components";

import { UIButton } from "common/components";

const topLevelContainerStyles = css`
  display: flex;
  flex: 3;
  width: 100%;
`;

export const SourceNotFoundDetailContainer = styled.div`
  ${topLevelContainerStyles}
  justify-content: center;
  align-items: center;
`;

export const SourceNotFoundContainer = styled.div`
  margin-top: 3rem;
  width: fit-content;
  display: flex;
  flex-direction: column;
  align-self: center;
  justify-self: center;
  align-items: center;
  padding: 1.5rem;
  border: 2px solid ${({ theme }) => theme.colors.inputBorder};
  border-radius: 0.5rem;
  row-gap: 1rem;
`;

export const NotFoundTextContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  row-gap: 0.5rem;
`;

export const NotFoundTitle = styled.h1`
  margin: 0;
  color: ${({ theme }) => theme.colors.textBright};
`;

export const NotFoundMessage = styled.p`
  margin: 0;
  color: ${({ theme }) => theme.colors.textFade};
`;

export const LoadingIndicatorContainer = styled.div`
  ${topLevelContainerStyles}
  justify-content: center;
  align-items: center;
`;

export const SourceDetailLayoutContainer = styled.div`
  ${topLevelContainerStyles}
  flex-direction: column;
`;

export const SourceDetailHeader = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;

export const SourceHeading = styled.h1`
  color: ${({ theme }) => theme.colors.textBright};
`;

export const ButtonsContainer = styled.div`
  display: flex;
  flex-direction: row;
  column-gap: 1rem;
`;

export const EditButton = styled(UIButton)`
  column-gap: 0.5rem;
`;

export const DeleteButton = styled(UIButton)`
  background-color: ${({ theme }) => theme.colors.red};
  column-gap: 0.5rem;

  &:hover,
  &:focus-visible {
    background-color: ${({ theme }) => theme.colors.redDark};
  }
`;
